var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFashionLeftImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 130,
    viewBox: "0 0 152 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.209 54.7553L143.33 52.8438L141.419 57.7227L146.297 59.6343L148.209 54.7553Z",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52447 88.0297L3.64551 86.1182L1.73396 90.9971L6.61292 92.9087L8.52447 88.0297Z",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151 115.06L144.46 110.44L143.73 118.42L151 115.06Z",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6304 119.54L43.0904 114.92L42.3604 122.89L49.6304 119.54Z",
    fill: "#FF8787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2601 10.8903C55.4306 10.8903 57.1901 9.13075 57.1901 6.96027C57.1901 4.78979 55.4306 3.03027 53.2601 3.03027C51.0896 3.03027 49.3301 4.78979 49.3301 6.96027C49.3301 9.13075 51.0896 10.8903 53.2601 10.8903Z",
    fill: "#FFA8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3203 16.54C11.2868 16.54 12.0703 15.7565 12.0703 14.79C12.0703 13.8235 11.2868 13.04 10.3203 13.04C9.35381 13.04 8.57031 13.8235 8.57031 14.79C8.57031 15.7565 9.35381 16.54 10.3203 16.54Z",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.04 74.8701C43.4289 74.8701 51.04 67.259 51.04 57.8701C51.04 48.4813 43.4289 40.8701 34.04 40.8701C24.6512 40.8701 17.04 48.4813 17.04 57.8701C17.04 67.259 24.6512 74.8701 34.04 74.8701Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9199 72.6602C44.3088 72.6602 51.9199 65.049 51.9199 55.6602C51.9199 46.2713 44.3088 38.6602 34.9199 38.6602C25.5311 38.6602 17.9199 46.2713 17.9199 55.6602C17.9199 65.049 25.5311 72.6602 34.9199 72.6602Z",
    fill: "#FFC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9502 59.7102C33.9102 63.1702 40.7202 61.9502 44.1802 56.9902",
    stroke: "#FA5252",
    strokeWidth: 1.4907,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6398 44.8994L27.2398 47.7394L31.6198 46.3894L30.0298 50.6894L32.6798 54.4394L28.0898 54.2594L25.3498 57.9294L24.0998 53.5194L19.7598 52.0394L23.5698 49.4894L23.6398 44.8994Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1299 43.5397L39.6299 42.6697L41.4799 38.4697L43.6899 42.4897L48.2599 42.9397L45.1199 46.2897L46.0999 50.7697L41.9499 48.8197L37.9899 51.1397L38.5599 46.5897L35.1299 43.5397Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5596 8.87012L63.3196 32.7201",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2002 101.85L64.0602 94.2197",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.38965 124.73L50.5797 103.86",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2703 18.5999C98.2703 18.5999 96.8804 22.2999 98.2904 22.5899C99.7004 22.8799 103.27 24.8499 103.27 25.0199C103.27 25.1999 94.2304 36.7699 94.2304 36.7699L86.8604 38.5799L90.4304 23.5899L91.0504 15.1699L98.2703 18.5999Z",
    fill: "#FFC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6504 107.61C93.9504 111.44 94.6804 116.88 94.8204 120.92C94.8604 122.14 94.7004 123.34 94.4404 124.53C94.1604 125.8 93.5204 126.54 93.7104 127.44C93.9404 128.54 95.2104 129.24 96.3104 129.03C97.4204 128.81 98.2804 127.84 98.5804 126.76C98.8804 125.66 98.6904 124.46 98.9904 123.36C99.4004 121.87 100.71 120.46 100.21 118.99C100.04 118.5 99.6904 118.1 99.3804 117.69C97.5704 115.32 96.9104 110.68 97.6304 107.79",
    fill: "#FFE3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.131 107.94C102.951 110.02 102.851 113.88 101.851 115.88C101.341 116.9 100.591 117.9 100.661 119.04C100.741 120.33 101.851 121.28 102.621 122.33C103.481 123.5 103.971 124.93 104.991 125.97C106.011 127.01 107.901 127.45 108.841 126.35C108.921 126.26 108.991 126.16 109.011 126.04C109.061 125.81 108.921 125.58 108.791 125.38C108.031 124.22 107.311 123.03 106.631 121.83C106.131 120.94 105.641 120.03 105.411 119.03C105.151 117.91 105.241 116.75 105.351 115.61C105.611 112.95 105.591 109.45 106.841 107.09",
    fill: "#FFE3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4304 22.8802L70.2504 12.4902L69.7304 5.75018C69.7304 5.75018 67.5904 -0.669819 66.8804 0.0401813C66.1704 0.750181 67.5904 5.04018 67.5904 5.04018L67.5204 8.20018C67.5204 8.20018 67.5904 5.04018 66.8704 4.33018C66.1504 3.62018 65.4404 10.0402 65.4404 10.0402L68.3404 14.7202L74.7504 27.6402L84.9004 28.2102L89.0004 20.7402L78.4304 22.8802Z",
    fill: "#FFE3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5801 105.661C72.5801 105.661 93.9901 109.941 106.83 108.511C119.68 107.081 123.99 102.801 123.99 102.801C123.82 106.431 121.98 70.8706 100.4 47.8506",
    fill: "#FFA8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4208 25.0204V35.0103C91.8508 32.0403 93.9908 31.4403 93.9908 31.4403L99.7008 22.8803L106.121 25.0204C106.121 25.0204 101.311 28.5904 100.501 33.5804C99.6908 38.5804 105.401 33.5804 105.401 33.5804C101.121 37.1504 99.6908 44.2803 99.6908 44.2803L100.401 49.0103L84.5108 48.5604L82.9008 35.5204C82.6808 33.7903 82.9508 32.0304 83.6608 30.4404L87.5108 21.8103C87.8708 21.0003 88.7208 20.5203 89.6008 20.6403L90.4308 20.7504",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.411 47.8604L92.5606 48.5704H84.0006C84.0006 48.5704 65.4506 71.4104 72.5806 105.66",
    fill: "#FFA8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1802 85.3306C86.2602 83.6206 85.4902 80.3906 88.4002 81.8006C89.5202 82.3506 90.2002 82.1506 90.1902 80.5606C90.1802 79.0106 88.4901 78.2906 89.2701 76.6406C89.7901 75.5306 91.6102 74.9806 91.4102 73.7006C91.3102 73.0306 90.1002 72.0906 89.7102 71.5606C88.8102 70.3506 88.5101 68.9806 88.0602 67.5706C87.2101 64.9006 84.8702 60.3506 89.5102 60.0506C91.0502 59.9506 92.1802 60.7306 93.1902 61.8906C94.4002 63.2906 94.0102 64.6606 93.8702 66.3606C93.7902 67.4006 94.6602 73.7606 96.8602 72.4906C97.6802 72.0206 97.0702 71.4706 97.1802 70.7606C97.3902 69.4106 98.0702 69.6206 99.3801 69.6606C103.79 69.8106 102.28 73.1906 101.25 76.1106C100.97 76.9006 100.63 77.7406 100.63 78.5906C100.62 79.5706 101.11 80.3906 100.57 81.3506C99.1902 83.8106 96.1201 81.8206 94.2001 83.2106C93.5001 83.7206 92.5602 84.9506 92.8202 85.9306C93.1002 86.9806 94.3001 87.0406 94.5602 88.1906C94.7901 89.1906 93.8402 90.7806 94.4302 91.6806C95.0402 92.6206 96.2902 92.2206 97.0502 91.6506C98.3002 90.7206 98.7602 89.5206 100.58 90.1506C102.14 90.6906 103.04 92.2506 102.53 93.8106C102.1 95.1306 100.29 96.4006 101.39 97.7806C102.55 99.2406 105.03 98.1706 105.99 100.021C106.52 101.041 105.65 103.991 106.82 104.311C108.24 104.701 109.86 101.311 110.42 100.391C110.94 99.5406 112.34 98.4506 111.91 97.5706C111.56 96.8406 109.82 96.4306 109.2 95.8106C108.49 95.0906 108.2 94.2706 108.21 93.2506C108.22 91.4106 109.07 89.2906 111.07 88.8406C113.17 88.3706 113.77 90.5806 113.82 92.2806C114.95 91.3606 116.18 92.0706 116.95 93.0706C118.45 95.0106 117.16 96.0506 116.26 97.8306C115.53 99.2706 115.91 99.0206 116.92 99.9006C117.67 100.551 117.96 101.391 118.21 102.381C119.2 102.231 120.54 101.571 121.4 102.511C121.81 102.971 121.87 104.421 121.87 104.291C121.87 104.291 113.18 110.381 90.3902 108.361C67.6002 106.341 77.3702 88.5506 83.1802 85.3306Z",
    fill: "#FF6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.12 85.2104C107.54 84.3504 106.47 82.6204 106.42 80.8204C106.39 79.6304 106.9 78.3104 108.01 77.8904C108.69 77.6304 109.47 77.7704 110.11 78.0904C111.15 78.6104 111.96 79.8404 111.57 80.9404",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.41 64.9799C110.41 64.9799 108.47 64.9199 108.27 65.3999C107.96 66.1699 107.89 67.0599 108.18 67.8399C108.47 68.6199 109.15 69.2699 109.97 69.4299C110.79 69.5899 111.48 68.5899 111.84 67.8399C111.83 67.8399 113.26 64.9799 110.41 64.9799Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.52 60.8406C105.1 60.2906 104.3 61.5606 104.19 62.2406C104.08 62.9206 104.33 63.6206 104.73 64.1906C105.13 64.7506 105.67 65.2006 106.2 65.6406C106.2 65.6406 107.77 63.8406 105.52 60.8406Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.26 75.1103C114.69 72.1203 112.85 77.5603 112.72 79.8403C112.68 80.5703 112.77 81.3703 113.26 81.9203C114.26 83.0503 116.43 82.6403 117.18 83.9503C117.78 85.0103 116.96 86.2803 116.21 87.2303C115.46 88.1803 114.72 89.5403 115.45 90.5203C116.19 91.5103 117.87 91.1003 118.62 90.1103C118.95 89.6703 119.3 89.0803 119.85 89.1203C120.32 89.1503 120.62 89.6703 120.61 90.1303C120.6 90.6003 120.37 91.0303 120.18 91.4503C119.79 92.3303 119.54 93.3303 119.82 94.2603C120.09 95.1803 122.3 99.3903 123.25 99.2303C123.25 99.2403 119.66 81.6103 116.26 75.1103Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1208 77.4906C72.7708 76.5406 75.0108 76.8706 75.9508 77.2406C77.3308 77.7806 78.5808 78.6606 79.5408 79.7906C80.1308 80.4806 80.6208 81.2706 80.8408 82.1506C81.0608 83.0306 81.0008 84.0006 80.5608 84.7806C80.5708 84.7806 77.2308 88.5706 73.1208 77.4906Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4305 74.34C78.7605 73.07 80.9905 75.18 81.4405 76.42C81.8805 77.66 81.6305 79.06 81.0405 80.23C81.0505 80.24 77.8605 76.57 78.4305 74.34Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.71 72.71C82.85 73.86 83.04 75.83 82.14 77.19L81.71 72.71Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4301 100.66C80.3501 100.11 81.0601 98.3598 81.3501 97.8798C81.6401 97.3998 82.1701 97.1198 82.6901 96.9198C83.4701 96.6098 84.2901 96.4198 85.1201 96.3598C85.6501 96.3198 86.2001 96.3298 86.6901 96.5198C87.7501 96.9398 88.3101 98.1098 88.5301 99.2298C88.7401 100.35 88.7101 101.51 89.0501 102.6C89.1501 102.93 89.3201 103.28 89.6301 103.43C89.9601 103.58 90.3401 103.47 90.6801 103.34C91.9401 102.86 93.2401 102.1 94.5501 102.44C96.8201 103.03 97.6501 106.58 99.9901 106.55C100.73 106.54 101.4 106.14 102.13 106.02C103.55 105.79 105.04 106.83 105.33 108.24C105.41 108.51 82.2701 112.96 80.4301 100.66Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8507 94.0799C85.6607 92.4599 90.9807 93.7199 92.4907 95.0399C93.5907 95.9899 94.3007 97.5799 93.7707 98.9399C93.7707 98.9399 90.4107 98.9199 86.8507 94.0799Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9004 91.8299C83.9804 91.3599 84.0604 90.8799 84.2804 90.4499C84.5004 90.0199 84.8704 89.6499 85.3404 89.5499C85.8204 89.4499 86.3104 89.6399 86.7504 89.8499C87.3604 90.1499 87.9704 90.5099 88.3804 91.0599C88.7904 91.5999 88.9904 92.3499 88.7304 92.9899C88.6704 93.1399 88.4704 93.2899 88.3804 93.1599",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.13 8.61035C101.13 8.61035 99.6601 9.70035 93.2601 9.16035L91.1401 13.0804C91.1401 13.0804 91.3101 11.4704 89.8001 12.1904C88.2901 12.9104 89.7101 16.8204 91.1401 16.2904C91.1401 16.2904 92.5501 21.3704 96.8501 20.8004C102.56 20.0204 101.13 8.61035 101.13 8.61035Z",
    fill: "#FFE3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7809 38.1106C79.0009 30.7306 88.4309 27.5606 87.5709 25.0206C87.1709 23.8506 90.3609 21.9706 90.4209 20.7406C90.4809 19.4706 87.8109 18.5106 86.8509 15.7406C86.1809 13.8106 86.5909 11.9106 87.4109 10.2706C89.4909 6.09061 94.3909 3.87061 98.8909 5.14061C99.4209 5.29061 99.9209 5.48061 100.371 5.74061C102.741 7.07061 101.661 10.5906 98.9409 10.4206C97.8709 10.3506 95.0609 10.0406 93.2809 9.33061L91.8509 13.6106C91.8509 13.6106 89.4809 11.5906 89.5909 13.6706C89.7009 15.7506 90.9909 16.1006 90.9909 16.1006C91.7909 17.7806 98.6309 36.7306 85.7809 38.1506",
    fill: "#FFA8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.69 43.5705C114.69 43.5705 103.99 47.1405 102.51 47.1405C101.55 47.1405 99.8904 45.9405 98.8504 45.0905C98.1804 44.5505 96.9804 43.7705 96.1404 43.5705C96.1404 43.5705 90.8404 45.6705 91.3804 46.5805C91.3804 46.5805 93.2104 48.5605 94.2504 48.5605H97.9004L100.8 49.8905C101.97 50.4305 103.27 50.6405 104.55 50.5405C117.15 49.5305 121.11 45.7105 121.11 45.7105C122.54 40.0005 106.12 25.0205 106.12 25.0205C106.12 25.0205 100.41 29.3005 100.41 35.0105C100.41 37.8705 105.41 33.5805 105.41 33.5805L114.69 43.5705Z",
    fill: "#FFE3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.89 124.091C107.07 125.121 104.82 123.691 104.19 124.801C104.19 124.801 105.41 127.201 109.02 127.621C109.01 127.631 109.38 122.211 107.89 124.091Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.94 118.96C101.63 119.95 102.24 121.56 102.24 124.15",
    stroke: "#FA5252",
    strokeWidth: 0.7136,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.87 117.47C101.36 116.61 103.17 121.26 102.89 122.21C102.89 122.21 99.5 119.86 100.87 117.47Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.63 117.73C97.62 119.16 97.57 121.21 98.5 122.7C98.5 122.7 100.78 121.6 100.21 118.98C99.64 116.36 98.63 117.73 98.63 117.73Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8 126.1C94.34 125.36 94.22 127.18 95.1 127.4C95.98 127.62 96.4 126.1 99 126.1C99 126.1 97.7 130 93.81 130C90.62 130 93.8 126.1 93.8 126.1Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6401 118.96C99.4401 119.63 99.7001 121.39 99.7001 124.21",
    stroke: "#FA5252",
    strokeWidth: 0.7136,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7607 118.13C95.1107 118.49 98.0707 116.72 98.3507 116.37",
    stroke: "#FA5252",
    strokeWidth: 0.7136,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.521 116.37C102.421 116.75 104.561 117.57 105.411 117.08",
    stroke: "#FA5252",
    strokeWidth: 0.7136,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2905 17.38C94.8105 17.74 96.3105 18.05 96.9105 18.06C97.5105 18.07 98.1005 17.88 98.6305 17.6C98.6305 17.59 97.4305 15.76 95.2905 17.38Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5107 12.6705C98.8607 12.4205 99.2807 12.2805 99.7007 12.2605C100.061 12.2405 100.461 12.3305 100.701 12.6005",
    stroke: "#FA5252",
    strokeWidth: 0.7136,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3906 11.9002C93.6606 11.6302 94.0906 11.5902 94.4706 11.6502C94.9906 11.7302 95.4806 11.9602 95.8806 12.3002",
    stroke: "#FA5252",
    strokeWidth: 0.7136,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6709 14.1604C98.9109 13.7604 99.4109 13.5404 99.8709 13.6304",
    stroke: "#FA5252",
    strokeWidth: 0.7136,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6504 13.0401C94.9204 13.0001 95.1804 13.1401 95.3704 13.3301C95.5604 13.5201 95.6904 13.7701 95.8104 14.0001",
    stroke: "#FA5252",
    strokeWidth: 0.7136,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4203 121.76C98.3503 122.86 98.5903 125.92 98.5603 126.27",
    stroke: "#FA5252",
    strokeWidth: 0.7136,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.87 120.681C101.87 120.681 104.83 126.751 107.43 126.751",
    stroke: "#FA5252",
    strokeWidth: 0.7136,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFashionLeftImage);
export default __webpack_public_path__ + "static/media/fashionLeftImage.24890e4a7b999db4af1b4f938b3d7018.svg";
export { ForwardRef as ReactComponent };